/* @flow */

import type { LeaderboardItem } from "shop-state/types";

import React from "react";
import cn from "classnames";

import styles from "./styles.scss";

type Props = {
  leaderboardRows: $ReadOnlyArray<LeaderboardItem>,
  currentLeaderboardUser?: LeaderboardItem | null,
};

const LeaderboardTable = ({ leaderboardRows, currentLeaderboardUser }: Props): React$Node => {
  if (leaderboardRows.length === 0) {
    return null;
  }

  return (
    <div
      className={cn(styles.leaderboardTable, "awardit-leaderboardWidgetTable")}
    >
      {leaderboardRows.map((item, i) => (
        <div
          key={`${item.name}-${i}`}
          className={cn(styles.tableItem, { [styles.currentUser]:
          currentLeaderboardUser && currentLeaderboardUser.name === item.name })}
        >
          <span className={styles.itemIndex}>{item.position}</span>
          <span className={styles.itemName}>{item.name}</span>
          <span className={styles.itemPoints}>{item.points}</span>
        </div>
      ))}
    </div>
  );
};

export default LeaderboardTable;
